import { Middleware } from "@reduxjs/toolkit"
import { RootState } from "../rootReducer"
import { saveDialogTopicsCollapsed } from "../../utility/dialogs/topicsCollapsedStorage"

const TOPICS_COLLAPSED_ACTIONS = new Set(["dialogs/setShowTopicsCollapsed"])

export const persistTopicsCollapsedMiddleware: Middleware<unknown, RootState> = store => next => action => {
    const result = next(action)

    if (TOPICS_COLLAPSED_ACTIONS.has(action.type)) {
        const { dialogs } = store.getState()
        saveDialogTopicsCollapsed(dialogs.showTopicsCollapsed)
    }

    return result
}
